var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatureMain3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m37.831 34.621.981-1.042-6.312-6.312a14.719 14.719 0 0 0 .95-1.869 5.858 5.858 0 0 0 .337-2.176 6.261 6.261 0 0 0-1.9-4.6 6.334 6.334 0 0 0-4.658-1.9 6.233 6.233 0 0 0-4.627 1.9 6.313 6.313 0 0 0-1.869 4.6 6.417 6.417 0 0 0 1.867 4.627 6.183 6.183 0 0 0 4.627 1.931 5.886 5.886 0 0 0 2.237-.368 14.621 14.621 0 0 0 1.992-1.042zm-10.6-6.374a4.743 4.743 0 0 1-3.531-1.47 4.9 4.9 0 0 1-1.44-3.555 4.743 4.743 0 0 1 1.475-3.522 4.995 4.995 0 1 1 7.048 7.079 4.843 4.843 0 0 1-3.555 1.468zM10.5 40.2a3.349 3.349 0 0 1-3.31-3.31V13.11A3.349 3.349 0 0 1 10.5 9.8h36.034a3.349 3.349 0 0 1 3.31 3.31v23.779a3.349 3.349 0 0 1-3.31 3.31zm-5.765 4.166a.749.749 0 0 1-.552-.184.746.746 0 0 1 0-.981.749.749 0 0 1 .552-.184h47.682a.551.551 0 0 1 .429.215.7.7 0 0 1 .184.46.663.663 0 0 1-.184.49.588.588 0 0 1-.429.184z",
    transform: "translate(3 5.2)",
    style: {
      fill: "#fff"
    },
    "data-name": "\\uADF8\\uB8F9 163567"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureMain3);
export default __webpack_public_path__ + "static/media/feature-main-3.c348117dd5ecb574e39372c4bd16b0df.svg";
export { ForwardRef as ReactComponent };